
import { getUrlParams } from './common-utils';

export const parseHobUrlToConfig = (url, baseUrl) => {
  const searchParams = getUrlParams(url); 
  let parsedData = {}
  if (searchParams && Object.keys(searchParams)?.length) {
    if (!searchParams['orgId'] && baseUrl?.length) {
      searchParams['orgId'] = baseUrl.toLowerCase().includes('makemytrip') ? 'MMT' : 'GI';
    }
    parsedData = {...searchParams}
  }
  return parsedData;
}

export default parseHobUrlToConfig;